import ContentLoader from 'react-content-loader';
import type { VoidFunctionComponent } from 'react';

const DependencyDrawerLoader: VoidFunctionComponent = () => (
  <div>
    <ContentLoader
      speed={2}
      width={600}
      height={420}
      viewBox="0 0 600 420"
    >
      {/* Title (wider, bold) */}
      <rect x="0" y="0" rx="6" ry="6" width="220" height="36" />
      {/* Version (smaller, right of title) */}
      <rect x="230" y="8" rx="4" ry="4" width="80" height="24" />
      {/* Buttons (Edit, Ignore) */}
      <rect x="0" y="56" rx="8" ry="8" width="64" height="36" />
      <rect x="80" y="56" rx="8" ry="8" width="80" height="36" />
      {/* Tabs (Details, Matches) */}
      <rect x="0" y="110" rx="8" ry="8" width="80" height="28" />
      <rect x="90" y="110" rx="8" ry="8" width="80" height="28" />
      {/* Divider */}
      <rect x="0" y="150" rx="2" ry="2" width="600" height="2" />
      {/* Details rows (with more vertical spacing) */}
      <rect x="0" y="170" rx="4" ry="4" width="420" height="22" />
      <rect x="0" y="202" rx="4" ry="4" width="340" height="22" />
      <rect x="0" y="234" rx="4" ry="4" width="380" height="22" />
      <rect x="0" y="266" rx="4" ry="4" width="320" height="22" />
      <rect x="0" y="298" rx="4" ry="4" width="360" height="22" />
      <rect x="0" y="330" rx="4" ry="4" width="300" height="22" />
    </ContentLoader>
  </div>
);

export default DependencyDrawerLoader;
